module.exports = __webpack_public_path__ + "img/works_titleist_m_btm_off_m.fe04fcab.png";